export const selectShippingCheckout = state => state.views.shippingCheckout;

export const selectShipping = state => state.views.shippingCheckout.shipping;

export const selectItemWithoutShipment = state =>
    state.views.shippingCheckout.itemWithoutShipment;

export const selectShipment = (state, shipmentId) =>
    state.views.shippingCheckout?.shipments?.find(
        shipment => shipment.shipmentId === shipmentId
    );
